<div class="task-progress">
  <div class="alert alert-danger" *ngIf="!stage && stage!=0">Missing "stage" argument</div>
  <div class="step step-0">
    <div class="icon done" *ngIf="stage > 0"><i class="fa fa-check"></i></div>
    <div class="icon selected" *ngIf="stage === 0">0</div>
    <div class="icon" *ngIf="stage < 0">0</div>
    <label i18n="first step on task edit form|The title first of the four steps in creating or editing a task shown in the progress indicator corresponding to the the configure task name, workspace and report step@@taskStepConfigTitle">Main Configuration</label>
  </div>

  <div class="connector">
    <svg style="height: 40px;" version="1.1" viewBox="0 0 21 42">
      <path
        style="fill:none;stroke:inherit;stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;"
        d="m 16.5,34.5 -6,6.5 -6,-6.5 6,6.5 V 2"
      />
    </svg>
  </div>
  <div class="step step-1">
    <div class="icon done" *ngIf="stage > 1"><i class="fa fa-check"></i></div>
    <div class="icon selected" *ngIf="stage === 1">1</div>
    <div class="icon" *ngIf="stage < 1">1</div>
    <label i18n="taskStepExportData@@taskStepExportData">Export Data</label>
  </div>
  <div class="connector">
    <svg style="height: 40px;" version="1.1" viewBox="0 0 21 42">
      <path
        style="fill:none;stroke:inherit;stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;"
        d="m 16.5,34.5 -6,6.5 -6,-6.5 6,6.5 V 2"
      />
    </svg>
  </div>
  <div class="step step-2">
    <div class="icon done" *ngIf="stage > 2"><i class="fa fa-check"></i></div>
    <div class="icon selected" *ngIf="stage === 2">2</div>
    <div class="icon" *ngIf="stage < 2">2</div>
    <label i18n="second step on task edit form|The title second of the four steps in creating or editing a task shown in the progress indicator corresponding to the the configure delivery step@@taskStepDeliveryTitle">Deliveries</label>
  </div>
  <div class="connector">
    <svg style="height: 40px;" version="1.1" viewBox="0 0 21 42">
      <path
        style="fill:none;stroke:inherit;stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;"
        d="m 16.5,34.5 -6,6.5 -6,-6.5 6,6.5 V 2"
      />
    </svg>
  </div>
  <div class="step step-3">
    <div class="icon done" *ngIf="stage > 3"><i class="fa fa-check"></i></div>
    <div class="icon selected" *ngIf="stage === 3">3</div>
    <div class="icon" *ngIf="stage < 3">3</div>
    <label i18n="third step on task edit form|The title third of the four steps in creating or editing a task shown in the progress indicator corresponding to the the configure schedule step@@taskStepScheduleTitle">Schedules</label>
  </div>
  <div class="connector">
    <svg style="height: 40px;" version="1.1" viewBox="0 0 21 42">
      <path
        style="fill:none;stroke:inherit;stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;"
        d="m 16.5,34.5 -6,6.5 -6,-6.5 6,6.5 V 2"
      />
    </svg>
  </div>
  <div class="step step-4">
    <div class="icon done" *ngIf="stage > 4"><i class="fa fa-check"></i></div>
    <div class="icon selected" *ngIf="stage === 4">4</div>
    <div class="icon" *ngIf="stage < 4">4</div>
    <label i18n="fourth step on task edit form|The title fourth of the four steps in creating or editing a task shown in the progress indicator corresponding to the the step revision step@@taskStepRevisionTitle">Done</label>
  </div>
</div>
